export default "__VITE_ASSET__U4vk2jBV__"